import axios from 'axios'

const state = {
    adminBuildingsTypes: [
        'частный дом',
        'многоэтажный дом',
        'коммунально-бытовое'
    ]
};

const getters = {
    adminBuildingsTypes: state => {
      return state.adminBuildingsTypes
    }
};

const mutations = {
    adminBuildingsTypes: (state, payload) => {
      return state.adminBuildingsTypes = payload
    }
};

const actions = {
    adminBuildingsTypes({commit}, data) {
      commit('adminBuildingsTypes', data)
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}